import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {saveAs} from 'file-saver';

@Component({
  selector: 'app-comprobante-pdfview',
  templateUrl: './comprobante-pdfview.component.html',
  styleUrls: ['./comprobante-pdfview.component.scss']
})
export class ComprobantePDFViewComponent implements OnInit {

  constructor(public confirmationComponentMatDialogRef: MatDialogRef<ComprobantePDFViewComponent>, @Inject(MAT_DIALOG_DATA) public data: [string, string])
  {

  }

  ngOnInit()
  {

  }

  download() {
    saveAs(this.data[0], this.data[1]);
  }

  close() {
    this.confirmationComponentMatDialogRef.close();
  }

}
